import { createBaseService } from '~/services/base.axios.service.js'
import { getRequestHeaders } from '~/services/helpers.js'

const service = createBaseService(getRequestHeaders)

export default service
